import axiosService from "./axios-service";

export const getTargets = async (data = {}) => {
  return axiosService.post(`/sales/incentive/fetch_target`, data);
};

export const addTarget = async (data) => {
  return axiosService.post(`/sales/incentive/upsert_target`, data);
};

export const deleteTarget = async (data) => {
  return axiosService.post(`/sales/incentive/delete_target`, data);
};

export const uploadTargetFile = (data) => {
  return axiosService.post(`/sales/incentive/v2/upsert_target`, data);
};
